import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { openURL } from '_utils';
import { screenMargin } from '_utils/sizes';
import { useThemeContext } from '_utils/themeContext';
import { InfoMessage, HeimeText } from 'Components';

const DisabledReportsMessage = ({ disabledLink }: { disabledLink: string }): ReactElement => {
    const { t } = useTranslation();
    const { theme } = useThemeContext();

    const linkIsEmail = disabledLink.includes('@');

    const handleDisableSupports = () => {
        if (linkIsEmail) {
            openURL(`mailto:${disabledLink}`, t, true);
        } else {
            openURL(disabledLink, t, true);
        }
    };

    return (
        <View style={{ margin: screenMargin }}>
            <InfoMessage
                message={
                    <HeimeText>
                        {t('reports:disabled')}
                        {linkIsEmail ? t('reports:disabled_mail') : t('reports:disabled_url')}
                        <HeimeText
                            onPress={handleDisableSupports}
                            style={{
                                color: theme.hyperText,
                                alignItems: 'flex-end',
                                marginLeft: 5,
                                marginTop: 5,
                            }}
                        >
                            {disabledLink}
                        </HeimeText>
                    </HeimeText>
                }
            />
        </View>
    );
};

export default DisabledReportsMessage;
